"use strict";

exports.__esModule = true;
exports.usePageContext = exports.PageContextProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var initialContext = {
  pageId: 0,
  pathname: '',
  type: '',
  locale: '',
  pageCount: 0,
  pageNumber: 0,
  paginationPaths: [],
  relatedPaths: {},
  meta: [],
  breadcrumbs: [],
  fileIds: [],
  isExcluded: false,
  isDevelopment: false
};
var PageContext = /*#__PURE__*/(0, _react.createContext)(initialContext);

var PageContextProvider = function PageContextProvider(_ref) {
  var children = _ref.children,
      pageContext = _ref.pageContext;
  return /*#__PURE__*/_react.default.createElement(PageContext.Provider, {
    value: pageContext
  }, children);
};

exports.PageContextProvider = PageContextProvider;

var usePageContext = function usePageContext() {
  var context = (0, _react.useContext)(PageContext);

  if (context === undefined) {
    throw new Error('usePostsContext was used outside of its Provider');
  }

  return context;
};

exports.usePageContext = usePageContext;